import { DateFilterOptions } from '../../../ManagedDataTable/interfaces';
import { DateFilterValue } from './interfaces';

export const getOperatorFromOption = (
  option: DateFilterOptions
): DateFilterValue['operator'] => {
  let operator: DateFilterValue['operator'] = '=';

  if (option === 'after') {
    operator = '>';
  } else if (option === 'on-or-after') {
    operator = '>=';
  } else if (option === 'before') {
    operator = '<';
  } else if (option === 'on-or-before') {
    operator = '<=';
  } else if (option === 'exactly') {
    operator = '=';
  }

  return operator;
};

export const getOptionBasedOnOperator = (
  operator: DateFilterValue['operator']
): DateFilterOptions => {
  if (operator === '<') {
    return 'before';
  } else if (operator === '<=') {
    return 'on-or-before';
  } else if (operator === '>') {
    return 'after';
  } else if (operator === '>=') {
    return 'on-or-after';
  } else if (operator === '=') {
    return 'exactly';
  }

  return 'all';
};
